<template>
  <span>
    <card v-for="(renouvellement, index) in orderedRenouvellements" :key="index" class="parc-profile-parc-date mb-2" v-bind:title="'Dates clefs du renouvellement ' + (index + 1)">
      <hr class="mt-1 mb-2" />
      <div >
        <div>
        <p>
            Type du renouvellement
            <i v-if="renouvellement.type">
            <span v-if="renouvellement.type == 'S'">Substantiel</span>
            <span v-if="renouvellement.type == 'N'">Notable</span>
            </i>
            <i v-else>{{ emptyField }}</i>
          </p>
          <p v-if="renouvellement.type == 'S'"
            :class="{
              'empty-field': !renouvellement.dateDepotDemandeAutorisation
            }">
            Dépôt du dossier de demande d'autorisation (ou du PC)
            <i v-if="renouvellement.dateDepotDemandeAutorisation">{{
              $filters.formatDate(renouvellement.dateDepotDemandeAutorisation)
            }}</i>
            <i v-else>{{ emptyField }}</i>
          </p>
          <p v-if="renouvellement.type == 'S'"
            :class="{
              'empty-field': !renouvellement.dateDelivranceAvisAutoriteEnvironnementale
            }">
            Délivrance de l'avis de l'autorité environnementale
            <i v-if="renouvellement.dateDelivranceAvisAutoriteEnvironnementale">{{
              $filters.formatDate(renouvellement.dateDelivranceAvisAutoriteEnvironnementale)
            }}</i>
            <i v-else>{{ emptyField }}</i>
          </p>
          <p v-if="renouvellement.type == 'S'"
            :class="{
              'empty-field': !renouvellement.dateDelivranceAutorisationIcpe
            }">
            Arrêté d'autorisation ICPE
            <i v-if="renouvellement.dateDelivranceAutorisationIcpe">{{
              $filters.formatDate(renouvellement.dateDelivranceAutorisationIcpe)
            }}</i>
            <i v-else>{{ emptyField }}</i>
          </p>
          <p v-if="renouvellement.type == 'S'"
            :class="{
              'empty-field': !renouvellement.dateDeclarationOuvertureChantierConstruction
            }">
            Déclaration de l'ouverture du chantier de construction
            <i v-if="renouvellement.dateDeclarationOuvertureChantierConstruction">{{
              $filters.formatDate(renouvellement.dateDeclarationOuvertureChantierConstruction)
            }}</i>
            <i v-else>{{ emptyField }}</i>
          </p>
          <p v-if="renouvellement.type == 'S'"
            :class="{
              'empty-field': !renouvellement.dateMiseEnService
            }">
            Mise en service
            <i v-if="renouvellement.dateMiseEnService">{{
              $filters.formatDate(renouvellement.dateMiseEnService)
            }}</i>
            <i v-else>{{ emptyField }}</i>
          </p>
          <p v-if="renouvellement.type == 'N'">
            Arrêté préfectoral complémentaire
            <i v-if="renouvellement.dateArretePrefectoralComplementaire">{{
              $filters.formatDate(renouvellement.dateArretePrefectoralComplementaire)
            }}</i>
            <i v-else>{{ emptyField }}</i>
          </p>
        </div>
      </div>
    </card>
  </span>
</template>
<script>
import { mapGetters } from "vuex";
import { renouvellementService } from "@/service/renouvellement.service.js";
import { StatsCard } from "@/components/index";
import _ from 'lodash';

export default {
  components: {
    StatsCard
  },
  data() {
    return {
      emptyField: "Non saisie"
    };
  },
  computed: {
    ...mapGetters({
      parc: "parc",
      renouvellements: "renouvellements",
      isRenouvellements: "isRenouvellements"
    }),
    orderedRenouvellements: function () {
      return _.orderBy(this.renouvellements, 'dateRenouvellement');
    },
  },
  created() {
    this.getRenouvellementsByParcId();
  },
  methods: {
    getRenouvellementsByParcId() {
      this.loading = true;

      renouvellementService
        .getRenouvellementsByParcId(this.parc.id)
        .then(data => {
          if (data) {
            this.$store.dispatch("saveRenouvellements", data);
          }

          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.parc-profile-parc-date {
  &.card {
    .card-header {
      padding: 20px 14px 0;
    }
  }
  i {
    display: block;
    margin-top: 5px;
    margin-left: 1px;
  }
}
</style>
